import { frontendURL } from '../../../helper/URLHelper';
import KanbanBoard from './pages/KanbanBoard.vue';

const commonMeta = {
  permissions: ['administrator', 'agent', 'manager'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban/board'),
    component: KanbanBoard,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'kanban_board',
        component: KanbanBoard,
        meta: commonMeta,
      },
    ],
  },
];
